/**
 * A translated line with its <b>…</b> parts in bold (BA-85 copy). The values are put in
 * after the markup is split, so a parent's schedule or device name can never be read as
 * markup, and React escapes it.
 */

import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface RichTextProps {
  i18nKey: string;
  values?: Record<string, string | number>;
}

export const RichText: React.FC<RichTextProps> = ({ i18nKey, values = {} }) => {
  const { t } = useTranslation();
  const names = Object.keys(values);
  // Each value becomes a control-character slot, filled back in after the split
  const slots = Object.fromEntries(names.map((name, i) => [name, `\u0001${i}\u0002`]));
  const fill = (text: string) =>
    names.reduce((out, name) => out.split(slots[name]).join(String(values[name])), text);
  const template = t(i18nKey, slots) as string;
  return (
    <>
      {template.split(/<b>(.*?)<\/b>/).map((part, i) => (i % 2 === 1
        ? <Box key={i} component="b" sx={{ color: 'text.primary', overflowWrap: 'anywhere' }}>{fill(part)}</Box>
        : <React.Fragment key={i}>{fill(part)}</React.Fragment>))}
    </>
  );
};
